export const preferenceGroups = {
  coordinateSystem: 'coordinateSystem',
  measurementSystem: 'measurementSystem',
  distanceUnitsMetric: 'distanceUnitsMetric',
  areaUnitsMetric: 'areaUnitsMetric',
  distanceUnitsUSC: 'distanceUnitsUSC',
  areaUnitsUSC: 'areaUnitsUSC',
};

export const measurementSystems = {
  usc: 'usc',
  metric: 'metric',
};

export const distanceUnits = {
  metric: {m: 'meters', km: 'kilometers'},
  usc: {
    ft: 'feet',
    mi: 'miles',
    nmi: 'nautical-miles',
  },
};
export const areaUnits = {
  metric: {
    m2: 'square-meters',
    km2: 'square-kilometers',
    ha: 'hectares',
  },
  usc: {
    ft2: 'square-feet',
    mi2: 'square-miles',
    nmi2: 'square-nautical-miles',
    ac: 'acres',
  },
};

export const coordinateSystems = {
  dd: 'decimal-degrees',
  dms: 'degrees-minutes-seconds',
  mgrs: 'military-grid-reference-system',
};
